<div class="loading">
  <video class="loading-cat"
         appAutoplayOnView
         muted
         loop
         src="assets/animation/loading-cat.webm">
  </video>
  <div class="loading--content">
    @if (title()) {
      <p class="title">{{ title() }}</p>
    }
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
